<!-- 
AddMultiGroupModal.vue
功能：群組複選視窗
作者：i9400538 陳博承
完成：2020-08-14
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="text-green m-0 mt-1">選擇群組</h3>
        </div>
        <div class="modal-body">
          <div class="row mt-2 mb-4" v-if="!group===false">
            <div class="col-12">
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                      type="text"
                      id="keyword-group"
                      class="form-control"
                      v-model="keyword"
                      placeholder="搜尋群組關鍵字..."
                      alt="ch"
                      maxlength="50"
                    />
                    <span v-show="keyword!==''" id="searchclear" @click="doClean()">清除</span>
                  </div>
                  <button
                    class="btn btn-primary btn-icon"
                    type="submit"
                    @click.stop.prevent="doSearch()"
                  >
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="radio radio-inline">
                <input type="radio" v-model="selectType" id="selectType1" value="1" />
                <label @click="clickLabel('1')">全部</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" v-model="selectType" id="selectType2" value="2" />
                <label @click="clickLabel('2')">已選擇 ({{selectedList.length}})</label>
              </div>
            </div>
          </div>
          <!-- all group block-->
          <div style="height:350px" v-show="selectType==='1'">
            <div class="list group">
              <div class="item" v-for="(item, i) in unSelectedGroup" :key="`group-all-item-${type}-${i}`">
                <div class="name">
                  <input
                    type="checkbox"
                    :id="`un-select-check-${type}-${item.val}`"
                    :value="item"
                    v-model="selectedList"
                    @click="addItem(item)"
                  />&nbsp;
                  <label :for="`un-select-check-${type}-${item.val}`"></label>
                  <label v-if="item.val==='withoutGroup'" class="span" :for="`un-select-check-${type}-${item.val}`">{{item.text}}</label>
                  <label v-else class="span color-green" :for="`un-select-check-${type}-${item.val}`">{{item.text}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- selected group block-->
          <div style="height:350px" v-show="selectType==='2'">
            <div class="list group">
              <div class="item" v-for="(item, i) in showList" :key="`group-item-${type}-${i}`">
                <div class="name">
                  <input
                    type="checkbox"
                    :id="`selected-check-${type}-${item.val}`"
                    :value="item"
                    v-model="selectedList"
                    @click="removeItem(item, i)"
                  />&nbsp;
                  <label :for="`selected-check-${item.val}`"></label>
                  <label v-if="item.val==='withoutGroup'" class="span" :for="`selected-check-${type}-${item.val}`">{{item.text}}</label>
                  <label v-else class="span color-green" :for="`selected-check-${type}-${item.val}`">{{item.text}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="cancel()" class="btn btn-default">取消</a>
                <a @click="$emit('submit',selectedList)" class="btn btn-primary">確定</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddMultiGroupModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    allGroup: {
      type: Array
    },
    selectedGroup: {
      type: Array
    },
    type: {
      type: String,
      default: ""
    }
  },
  watch: {
    selectedGroup: function() {
      this.registerHanlink();
    },
    unSelectedGroup: function() {
      this.registerHanlink();
    },
    open: function(val) {
      if (val == true) {
        this.unSelectedGroup = [...this.allGroup];
        this.unSelectedGroup.unshift(this.withoutGroup);
        this.selectedList = [...this.selectedGroup];
        this.showList = [...this.selectedGroup];
        this.keyword = '';
      }
    },
    selectType: "changeType",
    keyword: "changeKeyword"
  },
  data() {
    return {
      group: {},
      withoutGroup: {
        text: "無群組客戶",
        val: "withoutGroup"
      },
      keyword: "",
      selectedList: [],
      unSelectedGroup: [],
      selectType: "1",
      showList: [] //已選擇區塊顯示用
    };
  },
  methods: {
    doClean() {
      this.keyword = '';
    },
    doSearch() {
      if (this.selectType === "1") {
        //搜尋全部區塊
        if (this.keyword.trim() !== "") {
          let searchGroup = [...this.allGroup];
          searchGroup.unshift(this.withoutGroup);
          this.unSelectedGroup = searchGroup.filter(item => {
            const t = item.text.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || t.includes(this.ToDBC(s));
          });
        } else {
          this.unSelectedGroup = [...this.allGroup];
          this.unSelectedGroup.unshift(this.withoutGroup);
        }
      } else {
        //搜尋已選擇區塊
        if (this.keyword.trim() !== "" && this.selectedList.length > 0) {
          this.showList = this.selectedList.filter(item => {
            const t = item.text.toUpperCase();
            const s = this.keyword.toUpperCase();
            return t.includes(s) || t.includes(this.ToDBC(s));
          });
        } else {
          //顯示現有已選擇資料
          this.showList = [...this.selectedList];
        }
      }
    },
    ToDBC(str) {
      //  半形轉化為全形
      var result = "";
      var len = str.length;
      for (var i = 0; i < len; i++) {
        var cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        cCode = cCode >= 0x0021 && cCode <= 0x007e ? cCode + 65248 : cCode;
        //處理空格
        cCode = cCode == 0x0020 ? 0x03000 : cCode;
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    cancel() {
      this.selectType = '1';
      this.$emit("close");
    },
    changeType() {
      if (this.keyword.trim() !== '') {
        this.keyword = '';
      }
    },
    changeKeyword() {
      //檢查輸入欄位
      this.keyword = this.keyword.replace(/[<>!#$^&,"'?%*:;+{}[\]|~`=\\\s]/g,'');
      if (this.stringBytes(this.keyword, false, 50) > 50) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,50));
      }
      if (this.keyword === '') {
        if (
          this.unSelectedGroup &&
          this.unSelectedGroup.length != this.allGroup.length
        ) {
          this.unSelectedGroup = [...this.allGroup];
          this.unSelectedGroup.unshift(this.withoutGroup);
        }
        this.showList = [...this.selectedList];
      }
    },
    clickLabel(val) {
      if (this.selectType === val) {
        return;
      }
      this.selectType = val;
    },
    addItem(item) {
      let findIndex = this.showList.indexOf(item);
      if (findIndex === -1) {
        this.showList.push(item);
      } else {
        this.showList.splice(findIndex, 1);
      }
    },
    removeItem(item, index) {
      let findIndex = this.selectedList.indexOf(item);
      if (findIndex !== -1) {
        this.selectedList.splice(findIndex, 1);
      }
      this.showList.splice(index, 1);
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.span {
  &.color-green {
    color: green;
  }
  margin-left:10px;
  font-size: 20px;
  font-weight: bold;
}

.list {
  &.group {
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    margin-left: -17px;
    margin-right: -17px;
    max-height: 350px;
    overflow-y: scroll;
    border: 0 !important;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 17px;
      border: 0;
      box-shadow: none;
    }

    &::-webkit-scrollbar-track {
      box-shadow: none;
      border-radius: 0px;
      border: 0;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      width: 10px;
      border-radius: 20px;
      background-color: #555;
    }

    .item {
      position: relative;
      display: flex;
      height: 30px;
      width: calc(33% - 34px);
      margin-left: 17px;
      margin-right: 17px;
      margin-bottom: 20px !important;
      padding: 25px 10px 25px 20px;
      background: #fff;
      margin-bottom: 10px;
      align-items: center;
      align-content: center;
    }
  }
}
#searchclear {
  position: absolute;
  right: 25px;
  top: 14px;
  bottom: 0;
  margin-right: 58px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: green;
}

input[type=checkbox] {
  display: none;
}

input[type=checkbox] + label:before {
  content: '';
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left:0;
  top:0;
  bottom:0;
  margin-left:5px;
  margin-top:16px;
  color: darkorange;
  border: 2px lightgray solid;
  border-radius: 4px;
}

input[type=checkbox]:checked + label:before {
  content: "\e913";
  font-size: 16px;
  display: inline-block;
  line-height: 16px;
  text-align: center;
  font-family: icomoon;
  color: darkorange;
  border: 2px darkorange solid;
}
</style> 